import React, { useEffect, useState } from 'react';
import {Dialog, DialogContent, DialogActions} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import socketIOClient from 'socket.io-client';
import UrlasserDialog from '../../central/components/dialogs/UrlasserDialog';

// const PORT = process.env.NODE_ENV==="production"?443:5000;
// const ENDPOINT = `http://localhost:${PORT}`;

export default function BroadcastOff (props) {
    const {open, onClose} = props;
    const [isAnyUpdate, setIsAnyUpdate] = useState(null)
    const [disableConfirm, setDisableConfirm] = useState(true)

    const [openUrlasserDialog, setOpenUrlasserDialog] = useState(false);
    const [socket, setSocket] = useState(null); 

    const handleOpenUrlasserDialog = () => {
        setOpenUrlasserDialog(true);
    };
    const handleCloseUrlasserDialog = () => {
        setOpenUrlasserDialog(false);
    };

    const handleAfterVerify = () => {
        socket.emit('removeBroadcast', null);
        setOpenUrlasserDialog(false);
        document.getElementById('action-permitted').innerHTML='Update wurde erfolgreich abgesagt';
        setTimeout(() => {
            setIsAnyUpdate(null);
            onClose();
        }, 1000);

    }


    useEffect(() => {
        const so = socketIOClient();
        so.on('broadcast', (update) => {
            setIsAnyUpdate(update);
            if (update){
                setDisableConfirm(false);
            }    
        });
        setSocket(so);
        return () => so.disconnect();
    }, []);

    return (
        <div>
            <UrlasserDialog
                onVerifyClick={handleAfterVerify}
                onClose={handleCloseUrlasserDialog}
                open={openUrlasserDialog}
            />
            <Dialog open={open} onClose={onClose}>
                <AppBar position="static" color="primary">
                    <Toolbar>
                        <div><Typography variant="h5">Update abbrechen?</Typography></div>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    {
                        !isAnyUpdate && 
                        <p style={{color:'red', fontFamily:'Arial, Helvetica, sans-serif', fontSize:15}}>
                            Momentan sind keine Updates geplannt
                        </p>
                    }
                    <p id='action-permitted' style={{color:'green', fontSize:10, fontFamily:'Arial, Helvetica, sans-serif', marginTop:15}}/>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={onClose}>Abbrechen</Button>
                    <Button color="primary" variant="contained" disabled={disableConfirm} onClick={handleOpenUrlasserDialog}>
                        Bestätigen
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
};
